import { Component } from '@angular/core';

interface FooterLink {
    label: string;
    route: string;
}

interface SocialLink {
    icon: string;
    url: string;
    alt: string;
}

@Component({
    selector: 'app-footer-redesign',
    templateUrl: './footer-redesign.component.html',
    styleUrls: ['./footer-redesign.component.scss']
})
export class FooterRedesignComponent {

    exploreLinks: FooterLink[] = [
        { label: 'Home', route: '/home-redesign' },
        { label: 'About Us', route: '/about-redesign' },
        { label: 'Platform', route: '/platform-redesign' }
    ];

    menuLinks: FooterLink[] = [
        { label: 'Solutions', route: '/solutions-redesign' },
        { label: 'News', route: '/news-redesign' },
        { label: 'Contact', route: '/contact-redesign' }
    ];

    socialLinks: SocialLink[] = [
        {
            icon: '/assets/img/redesign/footer/facebook.svg',
            url: '#',
            alt: 'Facebook'
        },
        {
            icon: '/assets/img/redesign/footer/linkedin.svg',
            url: '#',
            alt: 'LinkedIn'
        },
        {
            icon: '/assets/img/redesign/footer/twitter.svg',
            url: '#',
            alt: 'Twitter'
        }
    ];

    trackByLabel(index: number, item: FooterLink): string {
        return item.label;
    }

    trackByAlt(index: number, item: SocialLink): string {
        return item.alt;
    }

}